import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// scrollRestoration is set to "manual" in index.html before React boots,
// so the browser never restores scroll. This component just ensures we're
// at the top on every route change.
const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Allow in-page anchor navigation (e.g. /#vixi) to control scrolling.
    if (location.hash) return;
    window.scrollTo(0, 0);
  }, [location.pathname, location.search, location.key]);

  return null;
};

export default ScrollToTop;
